"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccount = exports.AccountProvider = exports.AccountContextRef = void 0;
const react_1 = __importStar(require("react"));
const useLocalStorage_1 = require("hooks/useLocalStorage");
exports.AccountContextRef = react_1.default.createRef();
const initialState = {
    account: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setAccount: () => { }
};
const Context = (0, react_1.createContext)(initialState);
// Use this provider to allow access to the current account stored in local
// storage. The `account` variable can be used in hook dependencies for
// synchronization purposes.
const AccountProvider = ({ children }) => {
    const [account, setAccount] = (0, useLocalStorage_1.useLocalStorage)('account', null);
    const contextValue = { account, setAccount };
    (0, react_1.useImperativeHandle)(exports.AccountContextRef, () => contextValue);
    return react_1.default.createElement(Context.Provider, { value: contextValue }, children);
};
exports.AccountProvider = AccountProvider;
const useAccount = () => (0, react_1.useContext)(Context);
exports.useAccount = useAccount;
